<template>
  <div class="gs-library-empty">
    <div class="gs-library-empty__icon">
      <gs-icon name="play" size="28" />
    </div>
    <h2 class="gs-library-empty__title">
      {{ filtered ? 'No videos match' : 'Get started with your first video' }}
    </h2>
    <p class="gs-library-empty__copy">
      {{ filtered
        ? 'Try a different search or category.'
        : 'Paste a YouTube link, brand the player, add calls to action, then embed it anywhere.' }}
    </p>
    <gs-button v-if="!filtered" variant="primary" @click="$emit('add')">
      <gs-icon name="plus" size="16" />
      Add your first video
    </gs-button>
    <gs-button v-else variant="outline" @click="$emit('clear')">
      Clear filters
    </gs-button>
  </div>
</template>

<script>
export default {
  name: 'LibraryEmptyState',
  props: {
    filtered: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.gs-library-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 56px 24px;
  text-align: center;
}

.gs-library-empty__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
  color: var(--gs-primary);
  background: var(--gs-primary-soft);
  border-radius: 999px;
}

.gs-library-empty__title {
  margin: 0 0 8px;
  color: var(--gs-foreground);
  font-size: 18px;
  font-weight: 700;
}

.gs-library-empty__copy {
  max-width: 46ch;
  margin: 0 0 20px;
  color: var(--gs-muted-foreground);
  font-size: 14px;
  line-height: 1.55;
}
</style>
